import { useCallback, useState } from "react";
import { DashboardService } from "../../../../../core/http/services/DashboardService";

const useDashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentMatches, setRecentMatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ type: null, message: null });

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    setError({ type: null, message: null });

    const { status, data, message } = await DashboardService.getAdminDashboard();

    if (status !== 200) {
      setError({ type: "dashboard", message });
      setLoading(false);
      return;
    }

    setStats(data?.stats ?? null);
    setRecentMatches(data?.recentMatches ?? []);
    setLoading(false);
  }, []);

  return {
    stats,
    recentMatches,
    loading,
    error,
    fetchDashboard,
  };
};

export default useDashboard;
